import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { NumberingLinkedWithSalePatternQuery, NumberingLinkedWithSalePatternQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(NumberingLinkedWithSalePatternQuery)
@Wrapper(NumberingLinkedWithSalePatternQueryHandlerBase)
export class NumberingLinkedWithSalePatternQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
